export default __webpack_public_path__ + "static/itAllAddsUpCard2-5ec14fddff698ec8086a60acb5cef625.png";